var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "addInfoItem" },
    [
      _c("van-nav-bar", {
        attrs: { title: "录入成绩", "left-arrow": "" },
        on: { "click-left": _vm.onClickLeft },
      }),
      _c(
        "div",
        [
          _c(
            "van-form",
            { attrs: { examInfo: _vm.examInfo }, on: { submit: _vm.onSubmit } },
            [
              _c(
                "van-cell-group",
                { attrs: { inset: "" } },
                [
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      name: "exemDate",
                      label: "日期",
                      placeholder: "点击选择",
                    },
                    on: { click: _vm.columnsDateShowClick },
                    model: {
                      value: _vm.examInfo.examDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.examInfo, "examDate", $$v)
                      },
                      expression: "examInfo.examDate",
                    },
                  }),
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      name: "examSubject",
                      value: _vm.examInfo.examSubject,
                      label: "科目",
                      placeholder: "点击选择",
                    },
                    on: { click: _vm.columnsSubjectShow },
                  }),
                  _c("van-field", {
                    attrs: {
                      name: "分数",
                      label: "分数",
                      type: "number",
                      placeholder: "分数",
                      rules: [{ required: true, message: "请填写分数" }],
                    },
                    model: {
                      value: _vm.examInfo.examScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.examInfo, "examScore", $$v)
                      },
                      expression: "examInfo.examScore",
                    },
                  }),
                  _c("van-field", {
                    attrs: {
                      name: "排名",
                      label: "排名",
                      type: "number",
                      placeholder: "排名",
                      rules: [{ required: true, message: "请填写排名" }],
                    },
                    model: {
                      value: _vm.examInfo.examRank,
                      callback: function ($$v) {
                        _vm.$set(_vm.examInfo, "examRank", $$v)
                      },
                      expression: "examInfo.examRank",
                    },
                  }),
                  _c("van-field", {
                    attrs: { name: "描述", label: "描述", placeholder: "描述" },
                    model: {
                      value: _vm.examInfo.examDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.examInfo, "examDesc", $$v)
                      },
                      expression: "examInfo.examDesc",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { margin: "16px" } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: {
                        round: "",
                        block: "",
                        type: "primary",
                        "native-type": "submit",
                      },
                    },
                    [_vm._v(" 提交 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "mt-popup",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.columnsDateShow,
              expression: "columnsDateShow",
            },
          ],
          staticClass: "popup-input-box pa",
          attrs: {
            overlay: true,
            position: "top",
            "popup-transition": "popup-fade",
          },
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              formatter: _vm.formatter,
              title: "选择年月日",
              minDate: _vm.minDate,
              "max-date": _vm.maxDate,
            },
            on: { cancel: _vm.onCancelDate, confirm: _vm.onConfirmDate },
            model: {
              value: _vm.examInfo.examDate,
              callback: function ($$v) {
                _vm.$set(_vm.examInfo, "examDate", $$v)
              },
              expression: "examInfo.examDate",
            },
          }),
        ],
        1
      ),
      _c(
        "mt-popup",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.columnssujectShow,
              expression: "columnssujectShow",
            },
          ],
          attrs: { position: "top" },
        },
        [
          _c("van-picker", {
            ref: "ppkk",
            attrs: { title: "科目", "show-toolbar": "", columns: _vm.columns },
            on: {
              confirm: _vm.onConfirmgoods,
              cancel: _vm.onCancelSubject,
              change: _vm.onChangegoods,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }